<template>
  <div
    class="modal fade"
    id="previewModal"
    data-focus="false"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">預覽信件</h5>
          <button
            type="button"
            class="close"
            aria-label="Close"
            @click="$store.commit('OpenPreviewMailModal', false)"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <perfect-scrollbar class="modal-body">
          <div class="preview-body row">
            <div class="col-1">
              <Logo />
            </div>
            <div class="col-10" style="padding-left: 5px">
              收件者：<span
                v-for="(recipient, index) in previewMail.Recipients"
                :key="recipient[index]"
              >
                <el-tag size="small">{{
                  recipient.Name + "(" + recipient.Address + ")"
                }}</el-tag
                >;
              </span>
              <br />
              <template v-if="type !== 'job'">
                副本：<span
                  v-for="(cc, index) in previewMail.CCs"
                  :key="cc[index]"
                >
                  <el-tag size="small" type="info">{{
                    cc.Name + "(" + cc.Address + ")"
                  }}</el-tag
                  >;
                </span>
                <br />
              </template>
              <span>主旨：{{ previewMail.Subject }}</span>
            </div>
          </div>

          <div class="mt-1" v-html="previewMail.Body"></div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import Logo from "@/components/company/Logo.vue";

export default {
  props: ["type", "mail"],

  name: "PreviewMailModal",
  components: {
    Logo,
  },
  data() {
    return {
      api: "",
      // 預覽
      previewMail: {},
    };
  },

  computed: {
    ...mapGetters(["showPreviewMail"]),
  },

  watch: {
    showPreviewMail: async function (e) {
      if (e) {
        switch (this.type) {
          case "interview":
            this.api = "previewInterviewInvitation";
            break;
          case "thanks":
            this.api = "previewThanksMail";
            break;
          case "hire":
            this.api = "previewHireMail";
            break;
          case "job":
            this.api = "previewJobIntention";
            break;
        }
        await this.preview();
      } else {
        $("#previewModal").modal("hide");
      }
    },
  },

  methods: {
    // 預覽
    preview() {
      this.updateLoading(true);
      this.$api.sendmail[this.api](this.mail).then((response) => {
        if (response.status === 200) {
          this.previewMail = response.data;
          $("#previewModal").modal("show");
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
#previewModal {
  .modal-header {
    margin: 10px 10px 0 10px;
    .modal-title {
      display: inline-block;
    }
  }

  .modal-body {
    text-align: left;
    .preview-body {
      margin-top: 10px;
      span {
        margin-bottom: 5px;
      }
    }
  }
}
</style>
